import React, { useState, useMemo, useEffect } from 'react';
import moment from 'moment';
import {
  Divider,
  Card,
  Row,
  Col,
  DatePicker,
  Switch,
  notification
} from 'antd';
import DF from 'DisplayFramework';
import {
  GenPaymentParams,
  createAutoPayNetting
} from '../../../services/PaymentServices';
import JobResult from '../../Accounting/Components/JobResult';
import { useQuery } from 'react-query';
import FormInput from 'components/FormInput';
import { Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { dateToString } from 'utils/utils2';
import Button from 'components/Button';
import Title from 'components/Title';

import ThirdPartyInput from 'components/ThirdPartyInput';
import MGListByUser from 'components/MgListByUser';
import ParListSelect from 'components/ParListSelect';
import { getMgParValueByParCode } from 'services/parametersService';
import UtinaCard from 'components/UtinaCard';

const initialSearchParams: GenPaymentParams = {
  tpidstart: 0,
  tpidend: 1000000,
  duedate: moment() as any,
  currcode: '',
  mgid: Number(localStorage.getItem('mgid')),
  targetPayStatus: 'INIT',
  autoNetting: false
};

const AutoPayNetting = () => {
  const [form] = useForm();
  const [searchParams, setSearchParams] =
    useState<GenPaymentParams>(initialSearchParams);

  const loadPayTargetStatus = async () => {
    await getMgParValueByParCode({
      parcode: 'PAYINTS'
    })
      .then((response) => {
        if (response.data != null) {
          form.setFieldsValue({
            targetPayStatus: response.data.parvaluemin ?? 'INIT'
          });
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    loadPayTargetStatus();
  });

  const onFinish = (values: any) => {
    setSearchParams((prev) => ({
      ...prev,
      ...values
    }));
    setTimeout(refetch, 0);
  };

  const params = useMemo(
    () => ({
      ...searchParams,
      //   tpidstart: form.getFieldValue('tpidstart')?.tpid,
      //   targetPayStatus: form.getFieldValue('targetPayStatus') ?? 'INIT',
      currcode: form.getFieldValue('currcode'),
      duedate: dateToString(searchParams.duedate),
      flagForceNetAllocation: form.getFieldValue('flagForceNetAllocation'),
      flagUseCtrid: form.getFieldValue('flagUseCtrid'),
      mgid: form.getFieldValue('mgid'),
      tpidstart: form.getFieldValue('tpidstart')?.tpid,
      tpidend:
        form.getFieldValue('tpidend')?.tpid ??
        form.getFieldValue('tpidstart')?.tpid
    }),
    [form, searchParams]
  );

  const {
    data: jobResponse,
    refetch,
    isFetching
  } = useQuery(
    ['createAutoPayNetting', params],
    () =>
      createAutoPayNetting(params).then((res) => {
        notification.info({
          message: res.message,
          placement: 'bottomRight'
        });
        return res;
      }),
    {
      enabled: false
    }
  );

  return (
    <DF.Provider pagcode="autopaynetting">
      <Card
        title={<Title level={4} comcode="AutoPayNetting"></Title>}
        size="small"
      >
        <Form
          form={form}
          onFinish={onFinish}
          initialValues={initialSearchParams}
          layout="vertical"
        >
          <br></br>
          <Row>
            <Col md={19}>
              <Row gutter={20}>
                <Col md={15}>
                  <UtinaCard comcode="popoulationtotreat" level={5}>
                    <Row gutter={10}>
                      <FormInput col md={10} name="mgid">
                        <MGListByUser
                          userid={Number(localStorage.getItem('userid'))}
                        />
                      </FormInput>
                      <FormInput col md={7} name="currcode">
                        <ParListSelect parcode="CURRENCY" />
                      </FormInput>
                      <FormInput col md={7} name="duedate">
                        <DatePicker showToday />
                      </FormInput>

                      <FormInput col md={12} name="tpidstart">
                        <ThirdPartyInput
                          onSelected={(e) =>
                            form.setFieldsValue({ tpidend: e })
                          }
                        />
                      </FormInput>
                      <FormInput col md={12} name="tpidend">
                        <ThirdPartyInput
                          onSelected={(e) =>
                            form.setFieldsValue({ tpidend: e })
                          }
                        />
                      </FormInput>
                    </Row>
                  </UtinaCard>
                </Col>
                <Col md={6}>
                  <UtinaCard
                    style={{ height: '100%' }}
                    comcode="flagsautonetting"
                    level={5}
                  >
                    <Row>
                      <FormInput
                        col
                        md={24}
                        name="flagUseCtrid"
                        wrapperCol={{ span: 14 }}
                      >
                        <Switch />
                      </FormInput>
                      <FormInput
                        col
                        md={24}
                        name="flagForceNetAllocation"
                        wrapperCol={{ span: 14 }}
                      >
                        <Switch />
                      </FormInput>
                    </Row>
                  </UtinaCard>
                </Col>
              </Row>
            </Col>

            <Col
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <Button
                loading={isFetching}
                comcode="runservice"
                type="primary"
                htmlType="submit"
                style={{ width: 200, marginLeft: 15, height: 60 }}
              />
            </Col>
          </Row>
          <Row>
            <Col style={{ alignContent: 'center' }} xs={24}>
              {isFetching && (
                <Title level={3} type="danger" comcode="pleasewait" />
              )}
            </Col>
          </Row>
        </Form>
        <Divider></Divider>
        <UtinaCard comcode="result" level={5}>
          <JobResult jobResponse={jobResponse} entity="PAYMENT" />
        </UtinaCard>
      </Card>
    </DF.Provider>
  );
};

export default AutoPayNetting;
